import React from "react";
import ConfirmationModal from "../../../common/components/ConfirmationModal";
import ApiClient from "../../../common/API";
import { useQueryClient } from "react-query";
import { toast } from 'react-toastify';
import EmailIcon from '@mui/icons-material/Email';
import handleError from "../ErrorHandling"

export default function SendWelcomeEmail({ user, isOpen, setIsOpen }) {
    const queryClient = useQueryClient();

    const closeModal = () => {
        setIsOpen(false);
    };

    const handleSendEmail = () => {
        ApiClient().post(`user/${user.id}/send_welcome_email/`)
            .then(() => {
                closeModal();
                queryClient.invalidateQueries(['user'])
                toast.success('Welcome Email Sent!');
            })
            .catch(error => {
                console.error(error);
                const errorMessage = handleError(error, "User", "send_welcome_email");
                return toast.error(errorMessage);
            });
    };


    return (
        <>
            {isOpen && (
                <ConfirmationModal
                    isOpen={isOpen}
                    onClose={closeModal}
                    onConfirm={handleSendEmail}
                    icon={<EmailIcon sx={{ fontSize: '60px' }} color="primary" />}
                    title="Send Welcome Email"
                    message={`Send a welcome email to ${user?.first_name} ${user?.last_name} (${user?.email})?`}
                />
            )}
        </>
    )
}